export default "__VITE_ASSET__DoIbx94k__"